function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6.815 3.802a.69.69 0 01-.946 0l-2.364-2.26-2.364 2.26a.69.69 0 01-.945 0 .62.62 0 010-.904L3.033.186a.693.693 0 01.945 0l2.837 2.712c.26.25.26.654 0 .904",
  fill: "#FFF",
  fillRule: "evenodd"
});

function SvgDropdownUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 4
  }, props), _ref);
}

export default SvgDropdownUp;